import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import RozliczeniaKierowcowSearchbox from "./components/RozliczeniaKierowcowSearchbox";
import KierowcyService from "../../konfiguracja/zasobyConfig/kierowcy/KierowcyService";
import DateAndTimeFormat from "../../../utilities/DateAndTimeFormat";
import moment from 'moment'
import RaportyService from "../RaportyService";
import RozliczeniaKierowcowTable from "./components/RozliczeniaKierowcowTable";
import TrasyService from "../../konfiguracja/trasyConfig/trasy/TrasyService";
import ReactNotify from "react-notify";

export default class RozliczeniaKierowcowContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kierowcy: [],
            raporty: [],
            trasy: [],
            params: {
                "dataDo": DateAndTimeFormat.formatYYYYMMDD(moment()),
                "dataOd": DateAndTimeFormat.formatYYYYMMDD((moment())),
                "idKi": null,
                "idKu": null,
                "czyRozliczone": null,
            }

        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
        this.onClickRozlicz = this.onClickRozlicz.bind(this)
    }

    componentDidMount() {
        this.pobierzKierowcow()
        this.pobierzTrasy()

        this.onClickSzukaj(
            {
                "dataDo": DateAndTimeFormat.formatYYYYMMDD(moment()),
                "dataOd": DateAndTimeFormat.formatYYYYMMDD((moment())),
                "idKi": null,
                "idKu": null,
                "czyRozliczone": null,
            }
        )
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    pobierzKierowcow() {
        KierowcyService.getKierowcy().then(function (res) {
            if (Boolean(res)) {
                let arr = Array.from(res.data, item => {
                    return {
                        idKi: item.idKi,
                        imieNazwisko: item.imie + ' ' + item.nazwisko,
                        pesel: item.pesel,
                        stanowisko: item.stanowisko,
                        status: item.status,
                    }
                })
                this.setState({kierowcy: arr})
            }

        }.bind(this))
    }

    onClickSzukaj(params) {
        console.log(params)

        //  przekształcić params w params w url

        let paramsurl = '?dataOd=' + params.dataOd + '&dataDo=' + params.dataDo


        if (Boolean(params.idKi)) {
            paramsurl = paramsurl + '&idKi=' + params.idKi
        }

        if (Boolean(params.idKu)) {
            paramsurl = paramsurl + '&idKu=' + params.idKu
        }

        if (params.czyRozliczone !== null) {
            paramsurl = paramsurl + '&czyRozliczone=' + params.czyRozliczone
        }else  paramsurl = paramsurl + '&czyRozliczone=';

        RaportyService.pobierzRozliczeniaKierowcowUtargi(paramsurl).then(function (response) {

            if (response.status < 300) {

                let arr = Array.from(response.data, item => {
                    return {
                        ...item,
                        suma: parseFloat(item.kwotaJednorazowe) + parseFloat(item.kwotaMiesieczne),
                        kierowca: item.imie + ' ' + item.nazwisko
                    }
                })

                this.setState({
                    raporty: arr,
                    params: params,
                })
            }

        }.bind(this))

    }

    onClickRozlicz(obj){
        this.setState({rozliczanieInProgress: true})
        RaportyService.rozliczKursKierowcy(obj.idKu).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie rozliczono kurs', "", 3000)
                this.onClickSzukaj(this.state.params)
                this.setState({rozliczanieInProgress: false})
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas próby rozliczenia kursu', "", 3000)
            }
        }.bind(this))
    }

    onClickRozliczWszystko = (dane) => {
        console.log(dane)

        this.setState({rozliczanieInProgress: true})
        RaportyService.rozliczWszystkieKursyKierowcy(dane).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie rozliczono kursy', "", 3000)
                this.onClickSzukaj(this.state.params)
                this.setState({rozliczanieInProgress: false})
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas próby rozliczenia kursów', "", 3000)
            }
        }.bind(this))
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RaportyContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/raporty', text: 'Raporty'}, {
                                        addressUrl: '/raporty/rozliczenia-kierowcow',
                                        text: 'Rozliczenia kierowców'
                                    }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <RozliczeniaKierowcowSearchbox kierowcy={this.state.kierowcy} handleClickSzukaj={this.onClickSzukaj}/>
                        </Col>
                        <Col sm={12}>
                            <RozliczeniaKierowcowTable data={this.state.raporty}
                                                       trasy={this.state.trasy}
                                                       handleClickRozlicz={this.onClickRozlicz}
                                                       rozliczanieInProgress={this.state.rozliczanieInProgress}
                                                       handleClickRozliczWszystko={this.onClickRozliczWszystko}
                                                       params={this.state.params}
                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/RozliczeniaKierowcow/RozliczeniaKierowcowContainer.js